import { useBrowsing } from 'hooks/use-browsing';

export const useCaseInsensitiveParam = (targetKey: string) => {
	const { query } = useBrowsing();

	for (const key in query) {
		if (key.toLowerCase() === targetKey.toLowerCase()) {
			return query[key] as string;
		}
	}
	return null;
};
